import React from 'react'
import Lang from "@components/Lang/Lang";
import {Spin,Button,DatePicker,Form,Input,Row,Col,Select,Table,Tag} from 'antd';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {postOrderStatisticsList,postServiceCountryList} from "@/api/financeManagement";
import {toFixedWithCommas} from "@/utils/number-util";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import {getSomeTimeMilliseconds} from '@/utils/timeHandler'
import dayjs from 'dayjs';
import "./index.less";
import Detail from "./components/Detail";
import {Link} from "react-router-dom";
const { RangePicker } = DatePicker;
const { Search } = Input;
const config = require("../../../../config/config");

class OrderStatistics extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            keyword:'',
            listQuery:{
                beginTime:dayjs(new Date()).subtract(90,'days').format('YYYY-MM-DD'),
                endTime:dayjs(new Date()).format('YYYY-MM-DD'),
            },
            loading: false,
            serviceCountryList:[],
            list: [],
            model:{},
            pagingQuery: {
                pageSize: 50,
                total: 0,
                pageNum: 1
            },
        }
    }

    /**
     * 查询服务国家
     */
    getServiceCountry(callBack){
        postServiceCountryList({
        }).then(res=>{
            let models = res.data.models||[];
            this.setState({
                serviceCountryList:models,
                listQuery:{
                    ...this.state.listQuery,
                    saleCountryTransactionServiceId:models[0]&&models[0].id
                }
            },()=>{
                callBack();
            })
        })
    }

    /**
     * 获取数据源
     */
    getData(pageIndex){
        this.setState({
            loading: true
        }, () => {
            postOrderStatisticsList({
                ...this.state.listQuery,
                pagingQuery: {
                    pageIndex: pageIndex||this.state.pagingQuery.pageNum,
                    pageSize: this.state.pagingQuery.pageSize,
                },
            }).then(res => {
                let obj = {
                    loading:false,
                    list:[],
                }
                const response = res.data;
                const { success, valid,models=[],paging={},model={}} = response;
                if(success&&valid){
                    obj.list = models;
                    obj.model = model;
                    if(paging){
                        obj.pagingQuery = paging || {};
                    }
                }
                this.setState(obj);
            },()=>{
                this.setState({
                    loading:false,
                })
            })
        })
    }

    /**
     * 下载
     */
    download=()=>{
        var postData = {
            saleCountryTransactionServiceId:this.state.listQuery.saleCountryTransactionServiceId||''
        }
        if(this.state.listQuery.beginTime){
            postData.beginTime = Number(dayjs(this.state.listQuery.beginTime).valueOf());
        }
        if(this.state.listQuery.endTime){
            postData.endTime = Number(dayjs(this.state.listQuery.endTime).valueOf())+86399000;
        }
        $.ajax({
            url: "/service/mg/sale/po/download-statistics-list",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(postData),
            success:(res)=>{
                if(res.success&&res.valid){
                    window.open(res.model.fileUrl);
                }
            }
        });
    }

    /**
     * 修改服务国家
     */
    changeServiceCountry = (value) =>{
        let { listQuery } = this.state;
        listQuery.saleCountryTransactionServiceId = value;
        this.setState(
            {
                listQuery: {
                    ...listQuery
                },
            },
            () => {
                this.getData(1);
            }
        );
    }

    /**
     * 修改时间
     * @param date
     * @param dateString
     */
    timeChange = (date, dateString) => {
        let { listQuery } = this.state;
        listQuery.beginTime = dateString[0];
        listQuery.endTime = dateString[1];
        this.setState(
            {
                listQuery: {
                    ...listQuery
                },
            },
            () => {
                this.getData(1);
            }
        );
    };

    /**
     * changeInput
     * @param value
     */
    changeName = ({ target: { value } }) => {
        value = value
            .toString()
            .trim()
            .replace(/^\s+|\s+$/g, "");
        this.setState({
            keyword: value,
        });
    };

    /**
     * 搜索
     * @param value
     */
    search = (value) => {
        this.setState(
            {
                listQuery: {
                    ...this.state.listQuery,
                    keyword:this.state.keyword
                },
            },
            () => {
                this.getData(1);
            }
        );
    };

    /**
     * 切换分页
     * @param pagination
     */
    handlePagination = (pagination) => {
        this.getData(pagination.current);
    }

    /**
     * 获取Columns
     **/
    getColumns(props){
        let {saleCountryTransactionServiceId,model,beginTime,endTime} = props;
        return [
            {
                title: Lang({id: "KeHu", default: "客户"}),
                render: (text, record) => {
                    return <div>
                        <p color="font_14">
                            <Link className="num" to={`/customer/detail?id=${record.buyerId}`}>
                                {record.buyerCode}
                            </Link>
                        </p>
                        <p className="font_12">{record.buyerName}</p>
                    </div>
                }
            },
            {
                title: Lang({id: "YuE", default: "余额"}),
                render: (text, record) => {
                    return <div>
                        {toFixedWithCommas(record.balance,2)} {model.currencySymbol}
                    </div>
                }
            },
            {
                title: Lang({id: "ShengChangZhongDinDan", default: "生产中订单"}),
                render: (text, record) => {
                    return <div>
                        {toFixedWithCommas(record.productionOrderAmount,2)} {model.currencySymbol}
                    </div>
                }
            },
            {
                title: Lang({id: "DaiFuWeiKuanDinDan", default: "待付尾款订单"}),
                render: (text, record) => {
                    return <div>
                        {toFixedWithCommas(record.toBePayOrderAmount,2)} {model.currencySymbol}
                    </div>
                }
            },
            {
                title: Lang({id: "YiTiHuoDinDan", default: "已提货订单"}),
                render: (text, record) => {
                    return <div>
                        {toFixedWithCommas(record.pickedUpOrderAmount,2)} {model.currencySymbol}
                    </div>
                }
            },
            {
                title: Lang({id: "CaoZuo", default: "操作"}),
                align:'right',
                render: (text, record) => {
                    return <Detail buyerId={record.buyerId}
                                   beginTime={beginTime}
                                   endTime={endTime}
                                   saleCountryTransactionServiceId={saleCountryTransactionServiceId}>
                        <Button>{Lang({id: 'ChaKan', default: '查看'})}</Button>
                    </Detail>
                }
            }
        ]
    }

    componentDidMount() {
        this.getServiceCountry(()=>{
            this.getData();
        });
    }

    render() {
        let dataSource = this.state.list||[];
        let columns = this.getColumns;
        const {model,serviceCountryList} = this.state;
        const dateFormat = 'YYYY-MM-DD';

        return (
            <div  className="order-statistics-wrap">
                <CommonBreadcrumb
                    list={[
                        { name: Lang({id: '订单统计', default: 'DinDanTongJi'})}
                    ]}
                ></CommonBreadcrumb>
                <div className="main-wrap">
                    <Spin spinning={this.state.loading}>
                        {/*筛选项*/}
                        <div className="head-wrap">
                            <span className="title">{Lang({id: 'DinDanTongJi', default: '订单统计'})}</span>
                            <Form className="head-option-wrap" style={{width:'60%'}}>

                                {
                                    this.state.pagingQuery.total!=0?<AuthBtn auth={'OrderStatistics-Export-Button'}  className="export-style" onClick={this.download} title={Lang({id: 'XiaZai', default: '下载'})}>
                                    </AuthBtn>:null
                                }
                                
                                <Row gutter={[8,0]} className="flex1">
                                    <Col span={7}>
                                        <Form.Item className="country-wrap" label="">
                                            <Select placeholder={Lang({id:'GuoJia',default:'国家'})}
                                                    value={this.state.listQuery.saleCountryTransactionServiceId}
                                                    onChange={this.changeServiceCountry}>
                                                {
                                                    serviceCountryList.map((item,index)=>{
                                                        return <Select.Option key={index} value={item.id}>{item.name||'-'}</Select.Option>
                                                    })
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="">
                                            <RangePicker
                                                defaultValue={[
                                                    dayjs(this.state.listQuery.beginTime,dateFormat),
                                                    dayjs(this.state.listQuery.endTime,dateFormat)
                                                ]}
                                                format={dateFormat}
                                                style={{ width: "100%" }}
                                                placeholder={[
                                                    Lang({
                                                        id: "KaiShiShiJian",
                                                        default: "开始时间",
                                                    }),
                                                    Lang({
                                                        id: "JieShuShiJian",
                                                        default: "结束时间",
                                                    }),
                                                ]}
                                                onChange={this.timeChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={7}>
                                        <Form.Item label="">
                                            <Search
                                                style={{ width: "100%" }}
                                                placeholder={Lang({
                                                    id: "SouSuoKeHuBianHaoHuoMinCheng",
                                                    default: "搜索客户编号或名称",
                                                })}
                                                onChange={this.changeName}
                                                onSearch={this.search}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {/*统计项*/}
                        <ul className="count-wrap">
                            <li>
                                <div>
                                    <p>{Lang({id: "KeHuDeYuE",default: "客户的余额"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.balance,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "ShengChanZhongDingDan",default: "生产中订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.productionOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "DaiFuWeiKuanDingDan",default: "待付尾款订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.toBePayOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "YiTiHuoDingDan",default: "已提货订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.pickedUpOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <Table className="mt_16" dataSource={dataSource}
                               tableLayout="fixed"
                               columns={columns({
                                   model:model,
                                   beginTime:this.state.listQuery.beginTime,
                                   endTime:this.state.listQuery.endTime,
                                   saleCountryTransactionServiceId:this.state.listQuery.saleCountryTransactionServiceId
                               })}
                               rowKey="id"
                               onChange={this.handlePagination}
                               pagination={{
                                   defaultPageSize: this.state.pagingQuery.pageSize,
                                   total: this.state.pagingQuery.total,
                                   current: this.state.pagingQuery.pageIndex,
                                   showSizeChanger: false,
                               }}
                               />
                    </Spin>
                </div>
            </div>
        )
    }
}

export default OrderStatistics
